export const navBottomsContainer = {
    position: "absolute",
    // border: "1px solid red",
    width: "100vw",
    height: "100svh"
};

export const downArrowContainer = {
    position: "absolute",
    // border: "1px solid black",
    color: "white",
    cursor: "pointer",
    bottom: "0px",
    left: "10vw",
    height: "10svh",
    width: "80vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};

export const mobile_downArrowContainer = {
    position: "absolute",
    // border: "1px solid black",
    color: "white",
    cursor: "pointer",
    bottom: "0",
    left: "10vw",
    height: "5svh",
    width: "80vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};

export const upArrowContainer = {
    cursor: "pointer",
    position: "absolute",
    // border: "1px solid black",
    color: "white",
    left: "10vw",
    width: "80vw",
    height: "10vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};

export const mobile_upArrowContainer = {
    position: "absolute",
    // border: "1px solid black",
    color: "white",
    left: "10vw",
    width: "80vw",
    height: "5svh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer"
};
